import React from 'react';

import MyProfile from '../components/my_profile/MyProfile';

const MyProfilePage = () => <MyProfile />;

export default MyProfilePage;
